(function () {
  'use strict';

  // Heading + subheading copy for each lens. null = use the neutral schema text.
  var LENS_COPY = {
    '':       null,
    blanket:  { heading: 'Every mountain, its own blanket',    sub: 'Find your resort — shop its real trail map blanket.' },
    art:      { heading: 'Frame your home hill',               sub: 'Find your resort and shop its wall art print.' },
    poncho:   { heading: 'Après in your mountain\'s colors',   sub: 'Find your resort and shop its poncho.' },
    towel:    { heading: 'Take the mountain to the beach',     sub: 'Find your resort and shop its beach towel.' },
    puzzle:   { heading: '1,000 pieces of your mountain',      sub: 'Find your resort and shop its puzzle.' },
    hoodie:   { heading: 'Wear your mountain all day',         sub: 'Find your resort and shop its snug hoodie.' }
  };

  var GQL_FIELDS = '\n'
    + '      handle\n'
    + '      resort_name: field(key: "resort_name") { value }\n'
    + '      state:        field(key: "state")        { value }\n'
    + '      country:      field(key: "country")      { value }\n'
    + '      pass:         field(key: "pass_affiliation") { value }\n'
    + '      featured:     field(key: "featured")     { value }\n'
    + '      hero_image:   field(key: "hero_image")   {\n'
    + '        reference { ... on MediaImage { image { url altText } } }\n'
    + '      }\n'
    + '      resort_map:   field(key: "resort_map")   {\n'
    + '        reference {\n'
    + '          ... on MediaImage { image { url altText } }\n'
    + '          ... on GenericFile { url }\n'
    + '        }\n'
    + '      }\n';

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  // ---------------------------------------------------------------------------

  function PAResortPicker(root) {
    this.root          = root;
    this.shopDomain    = root.dataset.shopDomain  || '';
    this.token         = root.dataset.token       || '';
    this.pageSize      = parseInt(root.dataset.pageSize, 10) || 12;
    this.resortPrefix  = root.dataset.resortPrefix || 'resorts';
    this.defaultLens   = root.dataset.defaultLens || '';

    this.activeLens   = this.defaultLens;
    this.activeFilter = null; // string matched against pass OR state OR country
    this.query        = '';
    this.renderEnd    = this.pageSize;

    this.allResorts      = [];
    this.filteredResorts = [];

    // DOM
    this.grid        = root.querySelector('.pa-resort-picker__grid');
    this.countEl     = root.querySelector('.pa-resort-picker__count');
    this.searchInput = root.querySelector('.pa-resort-picker__search-input');
    this.showMoreBtn = root.querySelector('.pa-resort-picker__show-more');
    this.emptyEl     = root.querySelector('.pa-resort-picker__empty');
    this.headingEl   = root.querySelector('.pa-resort-picker__heading');
    this.subEl       = root.querySelector('.pa-resort-picker__subheading');
    this.lensButtons = root.querySelectorAll('.pa-resort-picker__lens');
    this.chipButtons = root.querySelectorAll('.pa-resort-picker__chip[data-filter]');

    // Stash initial heading/sub HTML so lens reset can restore rich text
    this.neutralHeadingHTML = this.headingEl ? this.headingEl.innerHTML : '';
    this.neutralSubHTML     = this.subEl     ? this.subEl.innerHTML     : '';

    this._init();
  }

  PAResortPicker.prototype._init = function () {
    var self = this;

    if (!this.token) {
      this._status('Add your Storefront API token in Theme Customizer → Resort Picker settings to load resorts.');
      return;
    }

    this._status('Loading resorts…');

    var promise = window.__PA_RESORTS
      ? Promise.resolve(window.__PA_RESORTS)
      : this._fetchAll();

    promise.then(function (resorts) {
      window.__PA_RESORTS = resorts;
      self.allResorts = resorts;
      self._bindEvents();
      if (self.defaultLens) {
        self._setLens(self.defaultLens, false);
      }
      self._applyFilters();
    }).catch(function (err) {
      self._status('Could not load resorts. Please refresh the page.');
      console.error('[PAResortPicker]', err);
    });
  };

  PAResortPicker.prototype._fetchAll = function () {
    var self     = this;
    var endpoint = 'https://' + this.shopDomain + '/api/2024-01/graphql.json';
    var headers  = {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': this.token
    };

    var resorts  = [];
    var cursor   = null;
    var hasNext  = true;

    function fetchPage() {
      var after = cursor ? (', after: "' + cursor + '"') : '';
      var gql   = '{ metaobjects(type: "resort_profile", first: 250' + after + ') {\n'
        + '  pageInfo { endCursor hasNextPage }\n'
        + '  nodes {\n' + GQL_FIELDS + '  }\n'
        + '} }';

      return fetch(endpoint, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ query: gql })
      }).then(function (resp) {
        if (!resp.ok) throw new Error('HTTP ' + resp.status);
        return resp.json();
      }).then(function (json) {
        if (json.errors && json.errors.length) {
          throw new Error(json.errors[0].message);
        }
        var data = json.data.metaobjects;
        resorts  = resorts.concat(data.nodes);
        hasNext  = data.pageInfo.hasNextPage;
        cursor   = data.pageInfo.endCursor;

        if (hasNext) return fetchPage();
        return resorts;
      });
    }

    return fetchPage();
  };

  PAResortPicker.prototype._bindEvents = function () {
    var self = this;

    if (this.searchInput) {
      this.searchInput.addEventListener('input', function () {
        self.query     = this.value.toLowerCase().trim();
        self.renderEnd = self.pageSize;
        self._applyFilters();
      });
    }

    this.lensButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self._setLens(btn.dataset.lens);
      });
    });

    this.chipButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self._setFilter(btn);
      });
    });

    if (this.showMoreBtn) {
      this.showMoreBtn.addEventListener('click', function () {
        self.renderEnd += self.pageSize;
        self._render();
      });
    }
  };

  PAResortPicker.prototype._setLens = function (lens, rerender) {
    this.activeLens = lens;

    this.lensButtons.forEach(function (btn) {
      var active = btn.dataset.lens === lens;
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var copy = LENS_COPY[lens] || null;
    if (this.headingEl) {
      if (copy) {
        this.headingEl.textContent = copy.heading;
      } else {
        this.headingEl.innerHTML = this.neutralHeadingHTML;
      }
    }
    if (this.subEl) {
      if (copy) {
        this.subEl.innerHTML = '<p>' + esc(copy.sub) + '</p>';
      } else {
        this.subEl.innerHTML = this.neutralSubHTML;
      }
    }

    if (rerender !== false) {
      this.renderEnd = this.pageSize;
      this._applyFilters();
    }
  };

  PAResortPicker.prototype._setFilter = function (btn) {
    var filterValue = btn.dataset.filter;

    if (filterValue === 'all') {
      this.activeFilter = null;
      this.chipButtons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    } else {
      var isActive = btn.getAttribute('aria-pressed') === 'true';
      this.chipButtons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      if (isActive) {
        this.activeFilter = null;
      } else {
        this.activeFilter = filterValue.toLowerCase();
        btn.setAttribute('aria-pressed', 'true');
      }
    }

    this.renderEnd = this.pageSize;
    this._applyFilters();
  };

  PAResortPicker.prototype._applyFilters = function () {
    var q = this.query;
    var f = this.activeFilter;

    this.filteredResorts = this.allResorts.filter(function (r) {
      var name    = ((r.resort_name && r.resort_name.value) || '').toLowerCase();
      var pass    = ((r.pass    && r.pass.value)    || '').toLowerCase();
      var state   = ((r.state   && r.state.value)   || '').toLowerCase();
      var country = ((r.country && r.country.value) || '').toLowerCase();

      if (q && name.indexOf(q) === -1) return false;
      if (f && pass !== f && state !== f && country !== f) return false;
      return true;
    });

    this._render();
  };

  PAResortPicker.prototype._render = function () {
    var visible = this.filteredResorts.slice(0, this.renderEnd);
    var hasMore = this.filteredResorts.length > this.renderEnd;

    if (this.emptyEl) this.emptyEl.hidden = visible.length > 0;

    if (visible.length === 0) {
      this.grid.innerHTML = '';
    } else {
      this.grid.innerHTML = visible.map(this._buildCard.bind(this)).join('');
    }

    if (this.showMoreBtn) this.showMoreBtn.hidden = !hasMore;
    this._updateCount();
  };

  PAResortPicker.prototype._updateCount = function () {
    if (!this.countEl) return;
    var total = this.filteredResorts.length;
    var shown = Math.min(this.renderEnd, total);
    if (total === 0) {
      this.countEl.textContent = 'No resorts found';
    } else if (shown >= total) {
      this.countEl.textContent = 'Showing all ' + total + ' resorts';
    } else {
      this.countEl.textContent = 'Showing ' + shown + ' of ' + total + ' resorts';
    }
  };

  PAResortPicker.prototype._buildCard = function (r) {
    var name    = (r.resort_name && r.resort_name.value) || '';
    var state   = (r.state   && r.state.value)   || '';
    var country = (r.country && r.country.value) || '';
    var pass    = (r.pass    && r.pass.value)    || '';
    var featured = r.featured && r.featured.value === 'true';
    var handle  = r.handle || '';

    var href = '/pages/' + this.resortPrefix + '/' + handle;

    // Image — hero first (MediaImage), resort_map as fallback (MediaImage or GenericFile)
    var heroImg = r.hero_image && r.hero_image.reference && r.hero_image.reference.image;
    var mapRef  = r.resort_map && r.resort_map.reference;
    var mapImg  = mapRef && (mapRef.image || (mapRef.url ? { url: mapRef.url, altText: null } : null));
    var img     = heroImg || mapImg;

    var mediaHTML;
    if (img && img.url) {
      var baseUrl = img.url.split('?')[0];
      var altText = esc(img.altText || name);
      var srcset  = baseUrl + '?width=300 300w, '
                  + baseUrl + '?width=500 500w, '
                  + baseUrl + '?width=800 800w';
      mediaHTML = '<img class="pa-photo-slot__img"'
        + ' src="' + baseUrl + '?width=400"'
        + ' srcset="' + srcset + '"'
        + ' sizes="(min-width:1200px) 300px,(min-width:990px) 25vw,(min-width:750px) 33vw,50vw"'
        + ' alt="' + altText + '"'
        + ' loading="lazy" width="400" height="400">';
    } else {
      mediaHTML = '<div class="pa-photo-slot__placeholder" aria-hidden="true"></div>';
    }

    // Badges
    var badgesHTML = '';
    if (featured) {
      badgesHTML += '<span class="pa-resort-card__featured-badge">&#9733; Featured</span>';
    }
    if (pass) {
      var slug = pass.toLowerCase().replace(/\s+/g, '-');
      badgesHTML += '<span class="pa-pass-badge pa-pass-badge--on-image">'
        + '<span class="pa-pass-badge__dot pa-pass-badge__dot--' + esc(slug) + '" aria-hidden="true"></span>'
        + esc(pass)
        + '</span>';
    }

    // Location label
    var location = '';
    if (state && country) {
      location = esc(state) + ', ' + esc(country);
    } else if (state) {
      location = esc(state);
    } else if (country) {
      location = esc(country);
    }

    var locationHTML = location
      ? '<p class="pa-resort-card__location">' + location + '</p>'
      : '';

    return '<li class="pa-resort-picker__item">'
      + '<a href="' + esc(href) + '"'
      + ' class="pa-resort-card"'
      + ' data-resort-name="' + esc(name.toLowerCase()) + '"'
      + ' data-pass="' + esc(pass.toLowerCase()) + '"'
      + ' data-state="' + esc(state.toLowerCase()) + '"'
      + ' data-country="' + esc(country.toLowerCase()) + '"'
      + ' aria-label="' + esc(name) + '">'
      + '<div class="pa-resort-card__media">' + mediaHTML + '</div>'
      + '<div class="pa-resort-card__overlay" aria-hidden="true"></div>'
      + '<div class="pa-resort-card__badges">' + badgesHTML + '</div>'
      + '<div class="pa-resort-card__body">'
      + '<p class="pa-resort-card__name">' + esc(name) + '</p>'
      + locationHTML
      + '</div>'
      + '</a>'
      + '</li>';
  };

  PAResortPicker.prototype._status = function (msg) {
    if (this.grid) {
      this.grid.innerHTML = '<li class="pa-resort-picker__status">' + esc(msg) + '</li>';
    }
  };

  // ---------------------------------------------------------------------------
  // Boot: find all picker roots on the page and instantiate

  function boot() {
    document.querySelectorAll('[data-resort-picker]').forEach(function (el) {
      new PAResortPicker(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
